import { CircularProgress } from "@mui/material";
import React from "react";

const LoadingSpinner = () => (
  <div className="flex justify-center">
    <CircularProgress />
  </div>
);
export default LoadingSpinner;
